<template>
  <v-widget title="Client Terbanyak">
    <div slot="widget-content">
      <div
        v-if="!area_loaded"
        class="layout justify-center align-center"
        style="padding: 200px 0"
      >
        <v-progress-circular
          indeterminate
          :size="40"
          :width="2"
          color="secondary"
        >
        </v-progress-circular>
      </div>
      <div v-else-if="areaData.datasets.length">
        <doughnut-chart :chartData="areaData"> </doughnut-chart>
      </div>
      <div
        v-else
        class="layout justify-center align-center"
        style="padding: 200px 0"
      >
        <h2>Belum ada data.</h2>
        <v-icon medium>sentiment_very_dissatisfied</v-icon>
      </div>
    </div>
  </v-widget>
</template>

<script>
import _ from "lodash";
import Material from "vuetify/es5/util/colors";
import VWidget from "@/components/widgets/VWidget";
import DoughnutChart from "@/components/chart/DoughnutChart";
import { mapState } from "vuex";

export default {
  name: "most-client",
  components: {
    VWidget,
    DoughnutChart
  },
  data() {
    return {
      color: Material,
      colors: [
        Material.red.base,
        Material.orange.base,
        Material.teal.base,
        Material.purple.base,
        Material.pink.base,
        Material.green.base,
        Material.indigo.base,
        Material.cyan.base,
        Material.yellow.base,
        Material.blue.base,
        Material.brown.base,
        Material.lime.base
      ]
    };
  },
  computed: {
    ...mapState("area", ["area_loaded"]),
    areaData() {
      let area = _.orderBy(
        this.$store.getters["area/areaByLaman"],
        o => {
          return parseInt(o.total_client);
        },
        ["desc"]
      );
      return {
        labels: area.map(ar => {
          return ar.area;
        }),
        datasets: [
          {
            data: area.map(ar => {
              return parseInt(ar.total_client);
            }),
            backgroundColor: this.colors
          }
        ]
      };
    }
  }
};
</script>
